/**
 * Customized route that Navigates non-admin users back to the homepage
 */

import React from 'react';
import { useSelector } from 'react-redux';
import session from '../../App/session';
import { Navigate, Outlet } from 'react-router-dom';

export const AdminRoute = () => {
    const isAuthenticated = useSelector(session.selectors.selectUserIsLogged);
    const userDetails = useSelector(session.selectors.selectUserDetails);
    const isAdmin = userDetails.userId === 1;

    if (!(isAuthenticated && isAdmin)) return <Navigate to="/app" />;
    return <Outlet />;
};

export default AdminRoute;
